import { PatientStatus } from "src/api/types";

export const patientStatuses: PatientStatus[] = [
  "Active",
  "Canceled",
  "Lead",
  "Onboarded",
  "Suspended",
  "Registered",
  "Paused",
  "Banned",
] as const;
